'use strict';

import $ from 'jquery';
import { once } from 'underscore';
import config from '../../js/config';
import utilities from '../../js/utilities';
import ModalView from '../../js/components/ModalView';
import CartUserService from '../../services/CartUserService';
import BomCollection from './BomCollection';
import BomModalCreate from './BomModalCreate';
import BomModalList from './BomModalList';
import BomModalControls from './BomModalControls';
import templateBomModal from './templates/BomModal.hbs';
import BomUnauthenticatedModal from './BomUnauthenticatedModal';
import userService from '../../services/CartUserService';

let instance = null;

class BomModal extends ModalView {
  initialize() {
    super.initialize({ template: templateBomModal, remodal: { closeOnOutsideClick: false } });
    this.collection = new BomCollection();
    this.createForm = new BomModalCreate({ collection: this.collection });
    this.list = new BomModalList({ collection: this.collection });
    this.controls = new BomModalControls({ collection: this.collection });

    this.listenTo(this.createForm, 'change:quantity', this.handleQuantityChange);
  }
  /**
   * Opens the modal
   *
   * @param {object} options
   * @param {string} options.partId
   * @param {string} options.partNumber
   * @param {string} options.manufacturerName
   * @param {string} [options.quantity = 1]
   */
  open(options) {
    this.partNumber = options.partNumber;
    this.partId = options.partId;
    this.manufacturerName = options.manufacturerName;
    this.quantity = options.quantity || 1;

    this.createForm.partId = this.partId;
    this.createForm.quantity = this.quantity;
    this.controls.partNumber = this.partNumber;
    this.controls.quantity = this.quantity;
    this.controls.manufacturerName = this.manufacturerName;

    super.open();
    this.fetchBomList();
  }

  modalClosing() {
    super.modalClosing();
    this.createForm.$el.detach();
    this.list.$el.detach();
    this.controls.$el.detach();
    this.$('#Modal-dialog-BomModal').removeAttr('aria-modal');
    $(this.bomButton).focus();
  }

  /**
   * Render the BOM Modal loader
   */
  render() {
    this.$el.html(this.template({ loaded: false }));
  }

  /**
   * Render the BOM Modal UI
   */
  renderModal() {
    let loginUrl = config.urls.loginPage;
    let loggedIn = CartUserService.isUserLoggedIn();

    // Generate login URL
    if (!loggedIn) {
      let openerUrl = utilities.queryStringUrl(document.location.href, {
        bomModal: true,
        partId: this.partId,
        partNumber: this.partNumber,
        manufacturerName: this.manufacturerName,
        quantity: this.quantity
      });
      loginUrl = utilities.queryStringUrl(loginUrl, { url: openerUrl });
    }

    let data = {
      loaded: true,
      loggedIn,
      loginUrl,
      partNumber: this.partNumber,
      bomList: this.collection.toJSON()
    };

    // Render child views
    this.createForm.render();
    this.list.render();
    this.controls.render();

    // Render main view
    this.$el.html(this.template(data));

    // Append child views
    let $modal = this.$('.BomModal');
    this.createForm.$el.appendTo($modal);
    this.list.$el.appendTo($modal);
    this.controls.$el.appendTo($modal);
    this.$('#Modal-dialog-BomModal').attr('aria-modal',true);
    this.$('#Modal-dialog-BomModal').parent().removeAttr('tabindex');
    this.controls.$bomModalElements = this.$el;
    this.bomButton = '#bom-' + this.partId;
    this.$('.BomModal-input')[0].focus();
    this.controls.reInitialize();
  }

  /**
   * Request the initial list of BOMs
   */
  fetchBomList() {
    this.collection.fetch({ reset: true, success: () => this.renderModal() });
  }

  handleQuantityChange(quantity) {
    this.quantity = quantity;
    this.createForm.quantity = this.quantity;
    this.controls.quantity = this.quantity;
  }

  /**
   * Handle the click event to open the BOM Modal
   *
   * @param {Event} e
   */
  static handleOpenerClicked(e) {
    e.preventDefault();
    if (!userService.isUserLoggedIn()) {
      BomUnauthenticatedModal.getInstance().open({});
    }
    else
    {
      BomModal.getInstance().open({
        partId: e.currentTarget.dataset.partId,
        partNumber: e.currentTarget.dataset.partNumber,
        manufacturerName: e.currentTarget.dataset.manufacturerName,
        quantity: e.currentTarget.dataset.quantity
      });
    }
  }

  /**
   * Check if we have returned from a login and need to automatically open modal
   */
  static postLoginCheck() {
    let urlInfo = utilities.deserialize(document.location.search);

    if (!urlInfo.bomModal) {
      return;
    }

    let { partId, partNumber, manufacturerName, quantity } = urlInfo;

    if (!partId || !partNumber) {
      return;
    }

    // Remove temporary bom parameters from URL
    if ('replaceState' in history) {
      delete urlInfo.bomModal;
      delete urlInfo.partId;
      delete urlInfo.partNumber;
      delete urlInfo.quantity;
      delete urlInfo.manufacturerName;
      let url = utilities.queryStringUrl(document.location.pathname, urlInfo);
      history.replaceState(null, '', url);
    }

    // Open modal
    BomModal.getInstance().open({ partId, partNumber, manufacturerName, quantity });
  }

  /**
   * Get the singleton instance of the BomModal.
   *
   * @returns {BomModal}
   */
  static getInstance() {
    if (!instance) {
      instance = new BomModal();
    }

    return instance;
  }
}

const oneTimePostLoginCheck = once(BomModal.postLoginCheck);

/**
 * Add click events to open BomModal.
 *
 * @param {jQuery} $parent
 */
export function createBomModal($parent) {
  // Defer function for modal elements
  setTimeout(() => {
    let $openers = $parent.find('.BomModal-opener');
    if ($openers.length) {
      $openers.unbind('click');
      $openers.on('click', BomModal.handleOpenerClicked);
    }
    oneTimePostLoginCheck();
  }, 2000);
}



// WEBPACK FOOTER //
// ./assets/components/BomModal/BomModal.js